export default __webpack_public_path__ + "static/rendition-200h-example-20d45df3852ee67c735b259e9e696434.gif";